module.exports = __webpack_public_path__ + "media/images/icon-close-f570a825d23064543e83809f98f79c32.svg";